import {Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Broadcast, ManualData} from "../../../model/broadcast/broadcast";
import {ControlAction} from "../../../model/broadcast/control";
import {UtilService} from "../../../services/util.service";
import {Game} from "../../../model/broadcast/game";
import {NgIf} from '@angular/common';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatIcon
  ]
})
export class StatusComponent implements OnInit, OnChanges, DoCheck {

  @Input() broadcast: Broadcast;
  @Input() game: Game;
  @Input() controlAction: ControlAction;
  @Input() simple?: boolean;
  @Input() preview?: boolean;
  @Input() manual?: boolean;

  public data: ManualData;

  constructor(
    public utilService: UtilService,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.manual) {
      this.data = this.broadcast?.manualData;
    } else if(this.game) {
      this.data = this.utilService.parseToManualData(this.game);
    }
  }

  ngDoCheck(): void {
    const isDiff = this.broadcast?.manualData?.index != this.data?.index;
    if (isDiff && this.manual && this.broadcast?.manualData?.index) {
      this.data = this.broadcast?.manualData;
    }
  }
}
